import { PureFunctional, React } from '../../react';

import cx from './style.less';

export interface ITabProps {
  active?: boolean;
  label?: string;
  id?: string;
}

export default PureFunctional<any|ITabProps>(`TabsTab`)(
  ({ active, children, id }) => (
    <div id={id} className={cx('tab', { active })}>
      {children}
    </div>
  ));



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/tabs/tab.tsx